// extracted by mini-css-extract-plugin
export var logo = "_ig-2";
export var logoWrapper = "_ig-1";
export var strip = "_ig-0";